import { combineReducers } from "redux";
import { releasenotesState } from "./releasenotesReducer";

export const releasenotesReducers = combineReducers({
    releasenotesState: releasenotesState
});
